<div class="login-container">
  
  <div class="brand-section">
    <div class="brand-content">
      <h1 class="cyber-title"><span class="prompt-arrow">>_</span> EstimatIA.</h1>
      <p class="cyber-subtitle">Plataforma de estimación de software potenciada por IA y contexto histórico RAG.</p>
    </div>
  </div>

  <div class="form-section">
    
    <form *ngIf="modo === 'login'" [formGroup]="loginForm" class="surface form-box" (ngSubmit)="onSubmitLogin()">
      <img src="../../../assets/images/logo-neon.png" alt="EstimatIA Logo" class="brand-logo" onerror="this.style.display='none'">
      
      <h2>Acceso al Sistema</h2>
      <p class="text-muted">Inicia sesión para continuar estimando.</p>
      
      <div class="social-login-buttons">
        <button type="button" class="btn secondary w-100" (click)="onLoginWithGoogle()">
          <svg class="icon-svg" viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
            <path fill="#e2e8f0" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#e2e8f0" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#e2e8f0" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#e2e8f0" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continuar con Google
        </button>
      </div>
      
      <div class="separator"><span>o usando tu email</span></div>
      
      <div class="form-group">
        <input type="email" class="form-control" placeholder="Correo electrónico" formControlName="username" required>
      </div>
      <div class="form-group">
        <input type="password" class="form-control" placeholder="Contraseña" formControlName="password" required />
      </div>
      
      <button type="submit" class="btn primary w-100 mt-3" [disabled]="!loginForm.valid">Ingresar al Terminal</button>
      
      <div class="auth-switch">
        ¿No tienes cuenta? <a routerLink="/" [queryParams]="{ modo: 'register' }" class="neon-link">Solicitar acceso</a>
      </div>
    </form>

    <form *ngIf="modo === 'register'" [formGroup]="registerForm" class="surface form-box" (ngSubmit)="onSubmitRegister()">
      <img src="../../../assets/images/logo-neon.png" alt="EstimatIA Logo" class="brand-logo" onerror="this.style.display='none'">
      
      <h2>Nuevo Usuario</h2>
      <p class="text-muted">Completa los datos para solicitar tu perfil.</p>
      
      <div class="form-group">
        <input type="text" class="form-control" placeholder="Nombre completo" formControlName="nombre" required>
      </div>
      <div class="form-group">
        <input type="email" class="form-control" placeholder="Correo electrónico" formControlName="username" required>
      </div>
      <div class="form-group">
        <input type="password" class="form-control" placeholder="Contraseña (mínimo 6 caracteres)" formControlName="password" required />
      </div>
      <div class="form-group">
        <input type="password" class="form-control" placeholder="Confirmar contraseña" formControlName="passwordConfirm" required />
      </div>
      
      <button type="submit" class="btn primary w-100 mt-3" [disabled]="!registerForm.valid">Enviar Solicitud</button>
      
      <div class="auth-switch">
        ¿Ya tienes cuenta? <a routerLink="/" [queryParams]="{ modo: 'login' }" class="neon-link">Inicia sesión</a>
      </div>
    </form>

    <div class="copyright">
      &copy; 2026 EstimatIA. Todos los derechos reservados.
    </div>

  </div>
</div>